import { render, staticRenderFns } from "./home-statistics.vue?vue&type=template&id=178cf6b5&scoped=true&"
import script from "./home-statistics.vue?vue&type=script&lang=js&"
export * from "./home-statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178cf6b5",
  null
  
)

export default component.exports